"use strict";

import { UIContainer } from "../uiContainer.js";

export class UIPanel extends UIContainer {
    constructor(config) {
        super(config);

        this.sortableChildren = true;

        this.forwardLayer = new UIContainer({
            parent: this,
            zIndex: 100
        });
    }

    onResolutionChanged() {
        this.sortChildren();
        super.onResolutionChanged();
    }
}